import TeamInboxFilled from "../shared/icons/teaminbox_filled.svg";
import TeamInboxOutlined from "../shared/icons/teaminbox_outlined.svg";
import CallFilled from "../shared/icons/call_filled.svg";
import CallOutlined from "../shared/icons/call_outlined.svg";
import ContactFilled from "../shared/icons/contact_filled.svg";
import ContactOutlined from "../shared/icons/contact_outlined.svg";
import Broadcast from "../shared/icons/broadcast1.svg";
import Broadcast1 from "../shared/icons/broadcast.svg";
import Tag from "../shared/icons/tag_outlined.svg";
import TagFilled from "../shared/icons/tag_filled.svg";
import Automation from "../shared/icons/automation_filled.svg";
import Automation1 from "../shared/icons/automation_outlined.svg";
import Home1 from "../shared/icons/home_outlined.svg";
import Home from "../shared/icons/home_filled.svg";
import AppointmentOutlined from "../shared/icons/appointment.svg";
import AppointmentFilled from "../shared/icons/appointment1.svg";
import Ticket from "../shared/icons/ticket_filled.svg";
import Ticket1 from "../shared/icons/ticket_outlined.svg";
import Plan from "../shared/icons/plan_filled.svg";
import Plan1 from "../shared/icons/plan_outlined.svg";
import Setting from "../shared/icons/setting_filled.svg";
import Setting1 from "../shared/icons/setting_outlined.svg";
import Person from "../shared/icons/person_filled.svg";
import Person1 from "../shared/icons/person_outlined.svg";
import Lead from "../shared/icons/lead_filled.svg";
import Lead1 from "../shared/icons/lead_outlined.svg";
import Chat from "../shared/icons/chat_filled.svg";
import Chat1 from "../shared/icons/chat_outlined.svg";

export const navSections = [
  {
    label: "Messaging",
    defaultOpen: true,
    items: [
      { id: "dashboard", label: "Home", path: "/dashboard", activeIcon: Home, inactiveIcon: Home1 },
      { id: "teamchat", label: "Team Inbox", path: "/teamchat", activeIcon: TeamInboxFilled, inactiveIcon: TeamInboxOutlined },
      { id: "calling", label: "Calling", path: "/calling", activeIcon: CallFilled, inactiveIcon: CallOutlined },
      { id: "chat-simulation", label: "Chat Simulation", path: "/chat-simulation", activeIcon: Chat, inactiveIcon: Chat1 },
      {
        id: "contacts",
        label: "Contacts",
        activeIcon: ContactFilled,
        inactiveIcon: ContactOutlined,
        children: [
          { id: "contacts-list", label: "Contacts", path: "/contacts" },
          { id: "group", label: "Groups", path: "/group" },
        ],
      },
      { id: "tags", label: "Tags", path: "/tags", activeIcon: TagFilled, inactiveIcon: Tag },
    ],
  },
  {
    label: "CRM",
    defaultOpen: true,
    items: [
      {
        id: "leads",
        label: "Leads",
        activeIcon: Lead,
        inactiveIcon: Lead1,
        children: [
          { id: "leads-board", label: "Pipeline", path: "/leads" },
          { id: "leads-list", label: "All Leads", path: "/leads/list" },
           { id: "leads-stages", label: "Pipeline Stages", path: "/leads/pipeline-stages" },
          { id: "leads-categories", label: "Categories", path: "/leads/categories" },
          { id: "quotations", label: "Quotations", path: "/quotations" },
        ],
      },
    ],
  },
  
  {
    label: "Campaigns",
    defaultOpen: true,
    items: [
      {
        id: "broadcast",
        label: "Broadcast",
        activeIcon: Broadcast,
        inactiveIcon: Broadcast1,
        children: [
          { id: "templates", label: "Templates", path: "/broadcast/templates" },
          { id: "broadcast-messages", label: "Broadcast Messages", path: "/broadcast/messages" },
        ],
      },
      {
        id: "automation",
        label: "Automation",
        activeIcon: Automation,
        inactiveIcon: Automation1,
        children: [
          { id: "automation-rules", label: "Rules", path: "/automation/rules" },
          { id: "automation-keyword-actions", label: "Keyword Actions", path: "/automation/keyword-actions" },
          { id: "automation-chatbots", label: "Chatbots", path: "/automation/chatbots" },
          { id: "automation-forms", label: "Forms", path: "/automation/forms" },
          { id: "inbound-email", label: "Inbound Email", path: "/inbound-email" },
          { id: "automation-ai-chatbot", label: "AI Chatbot", path: "/ai-chatbot" },
        ],
      },
    ],
  },
  {
    label: "Operations",
    defaultOpen: true,
    items: [
      { id: "appointments", label: "Appointments", path: "/appointments", activeIcon: AppointmentFilled, inactiveIcon: AppointmentOutlined },
      { id: "tickets", label: "Tickets & Reservations", path: "/tickets", activeIcon: Ticket, inactiveIcon: Ticket1 },
    ],
  },
  {
    label: "Account",
    defaultOpen: true,
    items: [
      { id: "plan", label: "Plans", path: "/plan", activeIcon: Plan, inactiveIcon: Plan1 },
      { id: "settings", label: "Settings", path: "/settings", activeIcon: Setting, inactiveIcon: Setting1 },
      { id: "team-members", label: "Team Members", path: "/team-members", activeIcon: Person, inactiveIcon: Person1 },
    ],
  },
];

export function flattenNavSearchItems(sections = navSections) {
  const items = [];
  sections.forEach((section) => {
    section.items.forEach((entry) => {
      if (entry.path) {
        items.push({
          id: `page-${entry.id}`,
          type: "page",
          label: entry.label,
          subtitle: section.label,
          path: entry.path,
        });
      }
      if (entry.children) {
        entry.children.forEach((child) => {
          items.push({
            id: `page-${child.id}`,
            type: "page",
            label: child.label,
            subtitle: `${section.label} · ${entry.label}`,
            path: child.path,
          });
        });
      }
    });
  });
  return items;
}

export function filterNavSearchItems(items, query) {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  return items.filter(
    (item) => item.label.toLowerCase().includes(q)
      || item.subtitle.toLowerCase().includes(q)
      || item.path.toLowerCase().includes(q)
  );
}
